import screenfull from 'screenfull';
import React from 'react';

import { kioskStore } from '../managers/globalState';
import DateTimeDisplay from './date_time_display';

import LightToggle from './light_toggle';
import SettingsMenu from './settings_menu';

import FullScreenButtonOnSVG from '../../www/assets/images/full_screen_button_on.svg';
import FullScreenButtonOffSVG from '../../www/assets/images/full_screen_button_off.svg';
import SpacecraftSVG from '../../www/assets/images/spacecraft.svg';

import '../../www/assets/css/controls_bar.css';
import '../../www/assets/css/date_time.css';


class Controls extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isFullScreen: false
		};

		this.toggleFullscreen = this.toggleFullscreen.bind(this);
		this.toggleTimeControls = this.toggleTimeControls.bind(this);

		// Listen to F11 key event to detect manual key fullscreen
		document.addEventListener('keyup', event => {
			const { isFullScreen } = this.state;

			if (!isFullScreen && event.code === 'F11') {
				this.toggleFullscreen();
			}
		});

		// On fullscreen api change event
		if (screenfull.isEnabled) {
			screenfull.on('change', () => {
				const { isFullScreen } = this.state;
				this.setState({ isFullScreen: !isFullScreen });
				props.setFullscreen(screenfull.isFullscreen);
			});
		}
	}

	componentDidMount() {
		this.kioskUnsubscribe = kioskStore.subscribeTo('kioskModeOn', () => this.forceUpdate());
	}

	componentWillUnmount() {
		typeof this.kioskUnsubscribe === 'function' && this.kioskUnsubscribe();
	}

	toggleTimeControls(on) {
		const { timeRateControlsRef, closeTimeControls, closeTimeControlsVisible } = this.props;

		let toggle = false;
		if (on === true) {
			if (!closeTimeControlsVisible) { toggle = true; }
		} else if (on === false) {
			if (closeTimeControlsVisible) { toggle = true; }
		} else { toggle = true; }

		if (toggle) {
			timeRateControlsRef.current.toggle();
			closeTimeControls(!closeTimeControlsVisible);
		}
	}

	toggleFullscreen() {
		screenfull.toggle();
	}

	render() {
		const { view, closeTimeControlsVisible, isMobile } = this.props;
		const { kioskModeOn } = kioskStore.stateSnapshot;
		const { isFullScreen } = this.state;

		if (isMobile) {
			return null;
		}

		const fullScreenSvg = isFullScreen ? <FullScreenButtonOffSVG /> : <FullScreenButtonOnSVG />;

		return (
			<div id='controls-bar' className='app-tools d-none d-lg-flex'>
				<ul className='mb-0 d-flex justify-content-around container-fluid'>
					<li>
						<div className={'hover-select d-flex flex-row align-items-center pr-2' + (closeTimeControlsVisible ? ' time-toggle' : '')} onClick={this.toggleTimeControls}>
							<ul>
								<li>
									<div className={'time-controls-link' + (closeTimeControlsVisible ? ' text-white' : '')}>
										<a>
                    <DateTimeDisplay />
									    {/* merge questions: I think we need to rebuild these guys... they aren't working anymore and running into a lot of errors
                      <ArabicDateDisplay className='DateDisplay'  utcLocal='local' format='earthDate' />
									    <ArabicTimeDisplay className='DateDisplay'  utcLocal='local' format='earthTime' updateInterval={500}/> */}
										</a>
									</div>
								</li>
								<li>
									<div className={'satellite-toggle' + (closeTimeControlsVisible ? ' time-toggle' : '')}>
										<SpacecraftSVG />
									</div>
								</li>
							</ul>
						</div>
					</li>
					<li>
						<SettingsMenu toggleTimeControls={this.toggleTimeControls} />
					</li>
					<li>
						<LightToggle
							enabled={view !== 'event'}
							isMobile={isMobile}
						/>
					</li>
					<li>
						{
							!kioskModeOn && screenfull.isEnabled
							&& (
								<button type='button' aria-label='toggle-fullscreen' className={'toggle-fullscreen' + (isFullScreen ? '' : ' secondary')} value='toggle' onClick={this.toggleFullscreen}>
									{fullScreenSvg}
								</button>
							)
						}
					</li>
				</ul>
			</div>
		);
	}
}

export default Controls;
